<template>
  <div :class="$style.root" @click="handleClick">
    <div class="u-relative">
      <img :class="$style.itemImg" :src="item.goodPreivewImage" />
      <span :class="$style.peopleNeed">{{ item.peopleNeed }}人团</span>
    </div>
    <div :class="$style.itemDetail">
      <div :class="$style.itemDetailRow1" v-html="item.goodName"></div>
      <div :class="$style.itemDetailRow2"> 已团{{ item.doneNum }}件 </div>
      <div :class="$style.itemDetailRow3">
        <span :class="$style.promptPrice"
          ><span :class="$style.priceSymbol">￥</span>{{ item.promptPrice }}</span
        ><span :class="$style.price"
          ><span :class="$style.priceSymbol">￥</span>{{ item.price }}</span
        >
        <button :class="$style.itemBtn">{{ btnText }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PinTuanItem",
  props: {
    item: {},
    btnText: {
      default: "我要开团",
    },
  },
  methods: {
    handleClick() {
      this.$emit("click", this.item);
    },
  },
};
</script>

<style lang="scss" module>
$page-width: 375;
@import "~style/tool";

.root {
  display: flex;
  padding: rem(15px);
  background-color: #fff;
  // position: relative;
}

.peopleNeed {
  position: absolute;
  left: 0;
  top: rem(6px);
  font-size: rem(12px);
  color: rgba(255, 255, 255, 1);
  background: rgba(233, 90, 89, 1);
  border-radius: 0px rem(15px) rem(15px) 0px;
  padding: rem(0) rem(6) 0 rem(4px);
  transform: scale(0.9);
  transform-origin: left center;
}

.itemImg {
  flex: 0 0 auto;
  display: block;
  width: rem(104px);
  height: rem(104px);
}

.itemDetail {
  line-height: 1;
  flex: 1 auto;
  margin-left: rem(9px);
  display: flex;
  flex-direction: column;
}

.itemDetailRow1 {
  line-height: 1.3;
  margin-top: rem(8);
  font-size: 14px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
}

.itemDetailRow2 {
  margin-top: rem(4);
  font-size: 11px;
  color: rgba(153, 153, 153, 1);
}

.itemDetailRow3 {
  margin-top: auto;
  display: flex;
  align-items: center;
}

.priceSymbol {
  font-size: rem(15px);
}

.promptPrice {
  font-size: rem(21px);
  font-weight: bold;
  color: rgba(233, 90, 89, 1);
}

.price {
  margin-top: rem(4);
  margin-left: rem(3);
  font-size: rem(15px);
  color: rgba(153, 153, 153, 1);
  text-decoration: line-through;
}

.itemBtn {
  margin-left: auto;
  border: 0;
  padding: rem(7px) rem(16px);
  height: rem(30px);
  font-size: rem(13px);
  border: 1px solid rgba(233, 90, 89, 1);
  color: rgba(255, 255, 255, 1);
  background: rgba(233, 90, 89, 1);
  border-radius: 15px;
}
</style>
